import { getEndPoint } from './getEndPoint'
export const getBlogPostBySlug = slug => {
  return import(/* webpackChunkName: "[request]" */ `wp-data/blog/${slug}.json`)
    .catch(() => {
      return getEndPoint(`wp/v2/posts/?slug=${slug}&_embed`)
    })
    .then(json => {
      return json[0]
    })
}
